/**
 * func to dynamically set authorization header on current JWT token with every call
 */
export default () => {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user && user.token)
        return { 'Authorization': 'Bearer ' + user.token }; 
    
    return {};
}